// src/pages/Home/Home.js
// import React from 'react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {


  // Image slider state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Dynamically import all images from assets folder
  const importAll = (r) => r.keys().map(r);
  const images = importAll(require.context('../assets', false, /\.(JPG|png|jpe?g|svg)$/));
  
  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
    
    return () => clearInterval(interval);
  }, [images.length]);
  
  // Navigation handlers
  const goToPrevious = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  
  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };





  const services = [
    {
      title: 'IT Infrastructure Solutions',
      icon: '🖥️',
      description: 'End-to-end IT infrastructure setup, cloud computing & hybrid solutions, network security & data protection.',
      color: '#4A7C59'
    },
    {
      title: 'Software & Digital Solutions',
      icon: '💻',
      description: 'Custom software development, enterprise resource planning (ERP) solutions, and business process automation.',
      color: '#6B9B7C'
    },
    {
      title: 'Data & Analytics',
      icon: '📊',
      description: 'Business intelligence & reporting, data engineering & management, AI-driven analytics & insights.',
      color: '#2E5A3D'
    },
    {
      title: 'Cloud & Managed Services',
      icon: '☁️',
      description: 'Cloud migration & optimization, IT support & managed services, cybersecurity & compliance solutions.',
      color: '#3D6B4E'
    },
    {
      title: 'Mobility & Workplace Solutions',
      icon: '📱',
      description: 'Enterprise mobility management, IT hardware procurement & deployment, unified communication tools.',
      color: '#5A8C6D'
    },
    {
      title: 'Talent Management',
      icon: '👥',
      description: 'End-to-end talent solutions including recruitment, workforce outsourcing, and strategic HR services.',
      color: '#487458'
    }
  ];

  const stats = [
    { number: '50+', label: 'Happy Clients' },
    { number: '100+', label: 'Projects Delivered' },
    { number: '2+', label: 'Years Experience' },
    { number: '24/7', label: 'Support' }
  ];

  return (
    <div className="home-page page-content">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Smart, Effective & <span className="highlight">Profitable</span>
                <br />Digital Solutions
              </h1>
              <p className="hero-description">
                We are redefining the future of IT solutions. As a new-age technology partner, 
                we bridge the gap between business challenges and innovative digital solutions.
              </p>
              <div className="hero-buttons">
                <Link to="/services" className="btn btn-primary">Explore Services</Link>
                <Link to="/contact" className="btn btn-secondary">Get Started</Link>
              </div>
            </div>
            
            {/* Image Slider */}
            <div className="hero-image">
              <div className="hero-graphic">
                {images.length > 0 && (
                  <>
                    <img 
                      src={images[currentImageIndex]} 
                      alt={`Slide ${currentImageIndex + 1}`}
                      className="slider-image"
                    />
                    
                    {/* Navigation Arrows */}
                    <button 
                      className="slider-arrow slider-arrow-left" 
                      onClick={goToPrevious}
                      aria-label="Previous image"
                    >
                      ‹
                    </button>
                    <button 
                      className="slider-arrow slider-arrow-right" 
                      onClick={goToNext}
                      aria-label="Next image"
                    >
                      ›
                    </button>
                    
                    {/* Dots Indicator */}
                    <div className="slider-dots">
                      {images.map((_, index) => (
                        <button
                          key={index}
                          className={`slider-dot ${index === currentImageIndex ? 'active' : ''}`}
                          onClick={() => setCurrentImageIndex(index)}
                          aria-label={`Go to slide ${index + 1}`}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <h3 className="stat-number">{stat.number}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="about-preview">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2 className="section-title">Who We Are</h2>
              <div className="title-line"></div>
              <p className="section-description">
                At Vista Elevations, we are more than just an IT solutions provider—we are your 
                trusted technology partner. Founded in 2024, we aim to bridge the gap between 
                business challenges and innovative digital solutions.
              </p>
              <p>
                Our expertise spans IT infrastructure, cloud, software development, data analytics, 
                and enterprise mobility solutions, helping businesses adapt, transform, and thrive 
                in the digital world.
              </p>
              <Link to="/about" className="btn btn-outline">Learn More About Us</Link>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <span className="placeholder-icon">🎯</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Services</h2>
            <div className="title-line"></div>
            <p className="section-subtitle">
              Comprehensive IT solutions designed to empower businesses with agility, efficiency, and innovation
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon" style={{ backgroundColor: service.color }}>
                  {service.icon}
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
          <div className="services-cta">
            <Link to="/services" className="btn btn-primary">View All Services</Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose Vista Elevations?</h2>
            <div className="title-line"></div>
          </div>
          <div className="choose-grid">
            <div className="choose-card">
              <div className="choose-icon">🎯</div>
              <h3>Expertise</h3>
              <p>Our team brings years of experience in delivering cutting-edge IT solutions</p>
            </div>
            <div className="choose-card">
              <div className="choose-icon">⚡</div>
              <h3>Innovation</h3>
              <p>We stay ahead with the latest technologies and industry best practices</p>
            </div>
            <div className="choose-card">
              <div className="choose-icon">🤝</div>
              <h3>Partnership</h3>
              <p>We work as your technology partner, not just a service provider</p>
            </div>
            <div className="choose-card">
              <div className="choose-icon">💼</div>
              <h3>Results</h3>
              <p>Focused on delivering measurable business outcomes and ROI</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>Let's discuss how we can help you achieve your digital transformation goals</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-white">Contact Us Today</Link>
              <a href="tel:+919311845556" className="btn btn-outline-white">Call: +91 93118 45556</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;